var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelicapLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 36,
    viewBox: "0 0 209 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_771_12300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.3975 11.3589V24.6397H53.8777V18.7212H46.0796V24.6397H44.5605V11.3589H46.0796V17.2571H53.8777V11.3589H55.3975Z",
    fill: "#152C52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1706 12.8037V17.2574H81.625V18.7222H74.1706V23.1961H82.5162V24.6407H72.6523V11.3599H82.5162V12.8044H74.1706V12.8037Z",
    fill: "#152C52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.46 11.3589V23.1951H107.772V24.6397H98.9414V11.3589H100.46Z",
    fill: "#152C52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.23 24.6397H123.711V11.3589H125.23V24.6397Z",
    fill: "#152C52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.594 20.6676H154.194C153.344 23.0955 151.156 24.8003 148.118 24.8003C144.086 24.8003 141.637 21.7709 141.637 17.999C141.637 14.2271 144.087 11.1978 148.118 11.1978C151.156 11.1978 153.344 12.9033 154.194 15.3304H152.594C151.906 13.7051 150.447 12.6618 148.239 12.6618C144.978 12.6618 143.155 15.0094 143.155 17.9983C143.155 20.9872 144.978 23.3348 148.239 23.3348C150.447 23.3348 151.906 22.2915 152.594 20.6661V20.6676Z",
    fill: "#152C52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.143 24.6397H180.462L178.821 20.7875H172.177L170.537 24.6397H168.855L174.547 11.3589H176.451L182.143 24.6397ZM178.234 19.4037L175.5 12.9235L172.764 19.4037H178.233H178.234Z",
    fill: "#152C52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.865 24.6402H198.346V11.3594H204.382C207.237 11.3594 208.999 13.0244 208.999 15.6323C208.999 18.2402 207.237 19.9052 204.382 19.9052H199.865V24.6394V24.6402ZM199.865 12.7837V18.5012H204.281C206.387 18.5012 207.481 17.4181 207.481 15.6323C207.481 13.8465 206.387 12.7837 204.281 12.7837H199.865Z",
    fill: "#152C52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8995 21.2864H11.709V19.2718H19.8729V27.4412C21.2155 27.1089 22.0348 26.6994 21.9977 25.1768C21.9 21.2031 21.9644 17.2265 21.9644 13.2498V11.7603C23.5319 12.1728 24.2437 12.841 24.1869 14.4731C24.0529 18.443 24.1165 22.4234 24.1634 26.3964C24.1634 27.3174 23.9385 27.8889 23.076 28.3284C21.3972 29.1797 19.813 30.1503 17.8964 31.2348L17.8995 21.2864Z",
    fill: "#152C52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.856 15.0526V17.0477H11.6278V8.8746C10.1269 9.26686 9.48626 9.90889 9.53321 11.415C9.65059 15.2919 9.57335 19.1755 9.57032 23.0524V24.6185C8.14367 24.1527 7.29782 23.6645 7.3478 22.0384C7.47199 18.0182 7.4152 13.9883 7.37128 9.96514C7.37128 9.0441 7.59618 8.47258 8.4655 8.03006C10.1443 7.17878 11.7285 6.19774 13.6087 5.12744V15.0496L19.856 15.0526Z",
    fill: "#152C52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9909 12.9972H17.916V5.16309C19.0542 5.79161 20.0075 6.30688 20.9374 6.84241C23.032 8.03271 25.1038 9.26276 27.218 10.4171C27.9291 10.7426 28.3531 11.4806 28.2721 12.2524C28.232 16.0828 28.1881 19.8997 28.2888 23.7436C28.3289 25.2362 27.6913 25.9247 26.1571 26.3237V24.3286C26.1571 20.595 26.1268 16.8576 26.1776 13.1232C26.2639 12.3589 25.8323 11.6299 25.1167 11.3313C23.4553 10.4606 21.8469 9.48927 19.9803 8.42872L19.9901 12.9972H19.9909Z",
    fill: "#152C52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.37133 10.0113V19.6739C5.37133 21.2467 4.92456 23.1188 5.62653 24.3121C6.32849 25.5062 8.20495 26.0282 9.57405 26.8322C10.148 27.1645 10.7387 27.4742 11.555 27.9228V23.4271H13.6299V31.0744C13.2179 30.9236 12.8143 30.7504 12.4213 30.5554C9.73534 29.0358 7.08044 27.4795 4.38464 25.9832C3.63194 25.6329 3.18365 24.8506 3.26695 24.0316C3.31389 20.2514 3.36084 16.4638 3.25029 12.6866C3.18668 11.1438 3.84472 10.429 5.37209 10.0098L5.37133 10.0113Z",
    fill: "#152C52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 26.9989V8.99737L15.7379 0L31.4757 9.00113V26.9996L15.7379 36.0007L0 26.9989ZM30.4951 9.55915L15.7242 1.12055L0.953373 9.55915V26.4371L15.7242 34.8757L30.4951 26.4371V9.55915Z",
    fill: "#152C52"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_771_12300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 209,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelicapLogo);
export default __webpack_public_path__ + "static/media/helicap_logo.a3545f0f6bcecb3923fedc2542ef2640.svg";
export { ForwardRef as ReactComponent };